module.exports = __webpack_public_path__ + "img/pci.e24371c5.svg";